<template>
  <div class="ma-4 pt-6">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn>
    </v-snackbar>
    <!-- dialog -->
    <StaffNav s/>
    <v-row class="hideOnPrint">
      <v-col cols="12" lg="3" xl="2">
        <StaffSide/>
      </v-col>
      <v-col  cols="12" lg="9" xl="10">
        <v-data-table
          :headers="headers"
          :items="adjustments"
          sort-by="Date"
          sort-desc
          class="elevation-1 "
          :loading="isLoading"
          loading-text="Loading Adjustments"
          :search="search"
          height="550"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Adjustments</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                clearable
                flat
                solo-inverted
                hide-details
                prepend-inner-icon="search"
                label="search"
                class="desktop"
              ></v-text-field>
              <v-spacer></v-spacer>
              
              <report-list-actions
                :reportOptions="reportOptions"
                :downloadFilename="reportListFilename"
              ></report-list-actions>
                <v-btn v-if="!isAuditorRole" color="#2b3990" class="mb-2 white--text" @click="showAdd()">
                  <v-icon left>add</v-icon>
                  Add Adjustment
                </v-btn>
            </v-toolbar>
            <v-text-field
              v-model="search"
              clearable
              flat
              solo-inverted
              hide-details
              prepend-inner-icon="search"
              label="search"
              class="mobile ml-5 mr-5 mb-3 mt-3"
            ></v-text-field>
          </template>

          <template v-slot:item.actions="{ item }">  
            <v-icon small class="mr-2" @click="downloadDocuments(item)">
              mdi-download
            </v-icon>
    
            <v-icon small class="mr-2" @click="viewAdjustment(item._id)">
              mdi-eye
            </v-icon>

            <v-icon v-if="!isAuditorRole" small @click="deleteAdjustment(item)">
              mdi-delete
            </v-icon>
          </template>

          <template v-slot:no-data>
            <v-btn color="#2b3990" class="white--text" @click="getAdjustments()">Reset</v-btn>
          </template>

        </v-data-table>
      </v-col>
    </v-row>
    </div>
</template>
<script>
  import axios from 'axios';
  import StaffNav from '@/components/StaffNav'
  import StaffSide from '@/components/StaffSide'
  import ReportListActions from '@/components/Report/ReportListActions.vue'
  
  const url = require("@/client_config/config").url;
  
  export default {
    components: { StaffNav, StaffSide, ReportListActions},
    data: function () {
      return {
        headers: [
          {
            text: 'Date',
            align: 'start',
            sortable: false,
            value: 'Date',
          },
          { text: "Description", value: "Description" },
          { text: "Reviewed By", value: "ReviewedBy" },
          { text: "Category", value: "Category" },
          { text: "Actions", value: "actions", sortable: false },
        ],
        adjustments: [],
        msg: false,
        text: "",
        isLoading: false,
        search: "",
        employeeID: this.$route.params.employeeID,
        uploadFile: "",
      };
    },
  
    computed: {    
      selectedEmployee() {
        return this.$store.state.users.allUsers.find(
            (user) => user._id == this.employeeID
        )
      },

      employeeName() {
        return this.selectedEmployee?.Name ?? this.staff
      },
      reportOptions() {
        return { 
          query: {
            name: this.employeeName,
          },
          endpoints: `adjustments/printList/${this.employeeID}`,
          dynamic: true
        }
      },
      reportListFilename() {
        return `${this.employeeName} - Adjustment`
      },
      isAuditorRole() {
        return localStorage.getItem("userRole") === 'Auditor'
      }

    },
  
    created() {
      this.getAdjustments();
    },
  
    methods: {
      getAdjustments: function() {
        this.isLoading = true;
        axios.get(`${url}/adjustments/staff/${this.employeeID}`).then(res => {
          this.adjustments = res.data.adjustments;
          for(var i=0;i<this.adjustments.length;i++){
            this.documentLink = this.adjustments[i].AdjustmentDocument
          }
        }).finally(() => this.isLoading = false);
      },      

      async downloadDocuments(item){
        if(item.documents === undefined){
          this.msg=true;
          this.text ="No document found";
        }else{
          for(let i = 0; i < item.documents.length ; i++){
            let docURL = item.documents[i].AWSLink;
            var FileSaver = require('file-saver');
            FileSaver.saveAs(docURL, item.documents[i].Name);
          }
        }
      },
      showAdd() {
        this.$router.push({
          path: `/Adjustments/${this.employeeID}/add`,
        });
      },
      
      viewAdjustment(id) {
        this.$router.push({
          path: `/Adjustments/${this.employeeID}/edit/${id}`,
        });

      },
      deleteAdjustment(item) {
        const id = item._id;
        confirm("Are you sure you want to delete this adjustment?") &&
        this.adjustmentDelete(id);
      },
      adjustmentDelete(id) {
        axios.delete(`${url}/adjustments/${id}`)
        .then((response) => {
          this.getAdjustments();
          if (response.status == 400) {
            response.json().then(function(data) {
              return data.msg;
            });
          }
          this.msg=true;
          this.text="The adjustment has been deleted successfully.";
        });
      },

      async fileSelected(e) {
        this.uploadFile= await this.renameFileHelper(e, this.staffName, "Adjustment", this.newDate);
      },

      uploadFiles(file) {
        const formData = new FormData();
        formData.append('adjustment', file);
        var ct = { headers:{"content-type" : "multipart/form-data"}};
        axios.post(`${url}/adjustments/fileuploader/${this.adjustmentID}/${this.employeeID}`,formData, ct)
        .then(res => {
          if(res){
            const adjustmentIndex = this.adjustments.findIndex(adjustment => adjustment._id === this.adjustmentID);
            if (adjustmentIndex !== -1) {
              this.adjustments[adjustmentIndex].documents.push(res.data.file);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
      }

    },
  };
  </script>
  <style>
  @media only screen and (min-width: 768px) {
    .mobile {
      display: none;
    }
  }
  
  @media only screen and (max-width: 600px) {
    .desktop {
      display: none;
    }
  }
  </style>